const Roles = {
	RESEARCHER: 'RESEARCHER',
};

export default Roles;
